import { create } from 'zustand';

function getInitialTheme(): 'dark' | 'light' {
  const stored = localStorage.getItem('site_theme') as 'dark' | 'light' | null;
  if (stored) return stored;
  if (window.matchMedia('(prefers-color-scheme: light)').matches) return 'light';
  return 'dark';
}

interface ThemeState {
  theme: 'dark' | 'light';
  toggle: () => void;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: getInitialTheme(),

  toggle: () => {
    const next = get().theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('site_theme', next);
    set({ theme: next });
  },
}));
